import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import {
  DEFAULT_CASINO_BUTTONS,
  DEFAULT_GAME_BUTTONS,
  loadStakeButtons,
  saveStakeButtons,
} from "./clientStakeButtons";
import "./Client.scss";

const ClientSetButtons = () => {
  const nav = useNavigate();
  const [tab, setTab] = useState("game");
  const [game, setGame] = useState(() => loadStakeButtons("game"));
  const [casino, setCasino] = useState(() => loadStakeButtons("casino"));

  useEffect(() => {
    setGame(loadStakeButtons("game"));
    setCasino(loadStakeButtons("casino"));
  }, []);

  const rows = tab === "game" ? game : casino;
  const setRows = tab === "game" ? setGame : setCasino;

  const updateRow = (idx, field, value) => {
    setRows((prev) =>
      prev.map((row, i) =>
        i === idx
          ? {
              ...row,
              [field]: field === "value" ? value.replace(/[^\d]/g, "") : value,
            }
          : row
      )
    );
  };

  const onSave = () => {
    const normalize = (list) =>
      list.map((r) => ({
        label: String(r.label || "").trim() || "btn",
        value: Math.max(1, Math.floor(Number(r.value) || 0)),
      }));
    const g = normalize(game);
    const c = normalize(casino);
    setGame(g);
    setCasino(c);
    saveStakeButtons(g, c);
    message.success("Button values saved");
  };

  const onReset = () => {
    if (tab === "game") {
      setGame(DEFAULT_GAME_BUTTONS.map((r) => ({ ...r })));
    } else {
      setCasino(DEFAULT_CASINO_BUTTONS.map((r) => ({ ...r })));
    }
    message.info("Reset to default");
  };

  return (
    <div className="w777-page w777-set-page">
      <div className="w777-set-btn-card">
        <div className="w777-set-btn-head">
          <span>Set Button Value</span>
          <button
            type="button"
            className="w777-set-close"
            aria-label="Close"
            onClick={() => nav(-1)}>
            ×
          </button>
        </div>

        <div className="w777-set-tabs">
          <button
            type="button"
            className={tab === "game" ? "active" : ""}
            onClick={() => setTab("game")}>
            Game Buttons
          </button>
          <button
            type="button"
            className={tab === "casino" ? "active" : ""}
            onClick={() => setTab("casino")}>
            Casino Buttons
          </button>
        </div>

        <div className="w777-set-table">
          <div className="w777-set-table-head">
            <span>Price Label</span>
            <span>Price Value</span>
          </div>
          {rows.map((row, idx) => (
            <div className="w777-set-row" key={`${tab}-${idx}`}>
              <input
                className="w777-set-label"
                value={row.label}
                maxLength={12}
                onChange={(e) => updateRow(idx, "label", e.target.value)}
              />
              <input
                className="w777-set-value"
                value={row.value}
                inputMode="numeric"
                onChange={(e) => updateRow(idx, "value", e.target.value)}
              />
            </div>
          ))}
        </div>

        <div className="w777-set-foot-bar" />

        <div className="w777-set-actions">
          <button type="button" className="w777-set-reset" onClick={onReset}>
            Reset
          </button>
          <button type="button" className="w777-set-save" onClick={onSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientSetButtons;
